import React, { type FC } from 'react'
import { ActionIcon, ActionType, Icon } from '@awell-health/design-system'

interface Props {
  tools?: {
    name: string
    description: string
    type: string
  }[]
}

const ActivityDetailsTools: FC<Props> = ({ tools }) => {
  const TOOL_ACTIONS = {
    calculation: ActionType.Calculation,
    form: ActionType.Form,
    extension: ActionType.Plugin,
    timer: undefined,
    message: ActionType.Message,
    dynamic_form: ActionType.Form
  }

  if (!tools || tools.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      {tools?.map(({ name, description, type }, index) => {
        const actionIcon = TOOL_ACTIONS[type as keyof typeof TOOL_ACTIONS]
        return (
          <div key={index} className="flex gap-4 p-4 rounded-lg border border-gray-200">
            <div className="grow-shrink-0">
              {actionIcon && <ActionIcon actionType={actionIcon} size="lg" />}
              {type === 'timer' && <Icon icon="RiTimerLine" size={24} />}
            </div>
            <div className="text-slate-900">
              <div className="text-gray-800 font-medium">{name}</div>
              <div className="text-gray-500 text-sm">{description}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ActivityDetailsTools
